export default __webpack_public_path__ + "static/media/Scultpsoft_Logo.8f584f36.svg";